import React from "react";
import "../../Components/Service/BbqArea.css";
import ServiceGallery from "./ServiceGallery";
import ContactForm from "../Contact/ContactForm";
import { useState } from "react";
import { useEffect } from "react";
import whatsappimg from "../../assets/whatsapp.png";
import phoneImg from "../../assets/reciever.png";
import DynamicSeo from "../../utils.seo/DynamicSeo";

const SmartPergola = () => {
  const [screenDimensions, setScreenDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    function handleResize() {
      setScreenDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const imageData = [
    {
      src: require("../../assets/SmartPergolaImages/1.jpg"),
      text: "Smart Pergola",
    },
    {
      src: require("../../assets/SmartPergolaImages/6.jpg"),
      text: "Smart Pergola",
    },
    {
      src: require("../../assets/SmartPergolaImages/4.jpg"),
      text: "Smart Pergola",
    },

    {
      src: require("../../assets/SmartPergolaImages/5.jpg"),
      text: "Smart Pergola",
    },
    {
      src: require("../../assets/SmartPergolaImages/7.jpg"),
      text: "Smart Pergola",
    },
    {
      src: require("../../assets/SmartPergolaImages/3.jpg"),
      text: "Smart Pergola",
    },
    {
      src: require("../../assets/SmartPergolaImages/8.jpg"),
      text: "Smart Pergola",
    },
    {
      src: require("../../assets/SmartPergolaImages/2.jpg"),
      text: "Smart Pergola",
    },
  ];
  const handleButton = () => {
    var url = "https://wa.me/+971565443552";
    window.open(url);
  };

  const handlePhoneButton = () => {
    window.location.href = "tel:+971565443552";
  };
  return (
    <>
      <DynamicSeo
        title="Smart Pergola | Automated Outdoor Living Redefined in the GCC"
        description="Experience luxury outdoor living with our premium Smart Pergola—crafted for the GCC climate. Featuring motorized louvers, weather sensors, and app control, it blends modern design with smart functionality for all-season comfort."
      />
      <div className="smartPergola">
        <div
          className="container-fluid"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            height: "100vh",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h2 className="text-white text-center py-5 font-face-re">
            Smart Pergola
          </h2>
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "70px",
          right: "20px",
          zIndex: "9999",
          height: "50px",
          width: "50px",
        }}
      >
        <img
          src={phoneImg}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50px",
            cursor: "pointer",
          }}
          onClick={handlePhoneButton}
          alt="phoneImg"
          loading="lazy"
        />
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "10px",
          right: "20px",
          zIndex: "9999",
          height: "50px",
          width: "50px",
        }}
      >
        <img
          src={whatsappimg}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50px",
            cursor: "pointer",
          }}
          onClick={handleButton}
          alt="whatsappimg"
          loading="lazy"
        />
      </div>
      <div className="container text-center">
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-10 py-5">
            <p className="my-0 py-0 font-face-rb">SMART PERGOLA</p>
            <p className="font-face-rr">
              Elevate your outdoor experience with refined, intelligent design.
            </p>
            <p className="font-face-rr">
              Engineered for effortless sophistication, our Smart Pergola
              combines minimalist elegance with cutting-edge automation. With
              sleek lines and motorized louvers, it adapts seamlessly to light
              and weather, offering a personalized retreat. Crafted with premium
              materials and subtle detailing, it becomes an architectural
              statement—quietly commanding and undeniably functional.
            </p>
            <p className="font-face-rr">
              More than shelter, it’s a curated space for stillness or social
              moments. Integrated lighting, weather sensors, and app control
              enhance comfort without clutter. Designed for timeless appeal, the
              Smart Pergola brings understated luxury to modern outdoor living.
            </p>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>

      <ServiceGallery imageData={imageData} />
      <div id="contact-us">
        <ContactForm />
      </div>
    </>
  );
};

export default SmartPergola;
